<template>
  <div>
    <div v-if="!embedded" class="page-head">
      <div>
        <h2>服务订单</h2>
        <p>处理咨询付费、服务购买和定制相关订单。</p>
      </div>
      <el-button type="primary" @click="openCreate">录入旅游订单</el-button>
    </div>

    <el-card v-if="!embedded" shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="客户编号/咨询编号/订单号/名称" clearable /></el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="待处理" value="pending" />
            <el-option label="处理中" value="processing" />
            <el-option label="已完成" value="completed" />
            <el-option label="已取消" value="cancelled" />
          </el-select>
        </el-form-item>
        <el-form-item label="收款状态"><el-select v-model="filters.settlement_status" placeholder="全部" clearable><el-option label="未收款" value="unsettled"/><el-option label="部分收款" value="partial"/><el-option label="已结清" value="settled"/><el-option label="已退款" value="refunded"/></el-select></el-form-item>
        <el-form-item label="核算状态"><el-select v-model="filters.finance_status" placeholder="全部" clearable><el-option label="待核算" value="pending"/><el-option label="核算中" value="processing"/><el-option label="已核算" value="completed"/></el-select></el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="order_no" label="订单号" width="190" />
        <el-table-column prop="customer_no" label="客户编号" width="205" />
        <el-table-column prop="consultation_no" label="来源咨询" width="205"><template slot-scope="{ row }">{{ row.consultation_no || '-' }}</template></el-table-column>
        <el-table-column prop="name" label="订单名称" min-width="170" />
        <el-table-column prop="order_type" label="类型" width="110">
          <template slot-scope="{ row }">{{ orderTypeText(row.order_type) }}</template>
        </el-table-column>
        <el-table-column prop="order_subtype" label="订单分类" width="110">
          <template slot-scope="{ row }">{{ orderSubtypeText(row.order_subtype) }}</template>
        </el-table-column>
        <el-table-column label="电子方案" width="110"><template slot-scope="{ row }">{{ row.order_subtype === 'custom' ? proposalStatusText(row.proposal_status) : '-' }}</template></el-table-column>
        <el-table-column prop="amount" label="金额" width="110" />
        <el-table-column prop="contract_amount" label="合同金额" width="110" />
        <el-table-column prop="confirmed_income" label="已收团款" width="110" />
        <el-table-column prop="confirmed_expense" label="确认成本" width="110" />
        <el-table-column prop="profit" label="利润" width="110" />
        <el-table-column label="服务需求" min-width="180"><template slot-scope="{ row }">{{ formatNeeds(row.service_needs_json) }}</template></el-table-column>
        <el-table-column prop="hotel_level" label="酒店标准" width="110" />
        <el-table-column prop="payment_status" label="支付状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.payment_status" /></template></el-table-column>
        <el-table-column prop="status" label="订单状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.status" /></template></el-table-column>
        <el-table-column label="下单时间" width="180"><template slot-scope="{ row }">{{ row.created_at | dateTime }}</template></el-table-column>
        <el-table-column label="操作" width="120"><template slot-scope="{ row }"><el-button type="text" @click="openEdit(row)">处理</el-button></template></el-table-column>
      </paged-table>
    </el-card>

    <component :is="embedded ? 'div' : 'el-dialog'" v-loading="travelersLoading" :title="isCreate ? '录入旅游订单' : '处理服务订单'" :visible.sync="drawerVisible" width="86%" top="4vh">
      <el-form class="drawer-form" :model="form" label-width="120px">
        <el-form-item v-if="isCreate" label="关联用户ID"><el-input-number v-model="form.user_id" :min="1" /><div class="field-help">填写已注册的小程序用户ID，创建后不可修改。</div></el-form-item>
        <el-form-item v-else label="订单号"><el-input v-model="form.order_no" disabled /></el-form-item>
        <el-form-item v-if="!isCreate" label="客户编号"><el-input v-model="form.customer_no" disabled /></el-form-item>
        <el-form-item v-if="!isCreate" label="来源咨询"><el-input :value="form.consultation_no || '无直接关联咨询'" disabled /></el-form-item>
        <el-form-item label="订单名称"><el-input v-model="form.name" /></el-form-item>
        <el-form-item v-if="!isCreate" label="关联用户"><el-input :value="`${form.user_nickname || '-'}（ID ${form.user_id || '-'}）`" disabled /></el-form-item>
        <el-form-item v-if="!isCreate" label="关联产品"><el-input :value="`${form.product_title || form.name || '-'}（ID ${form.product_id || '-'}）`" disabled /></el-form-item>
        <el-form-item v-if="!isCreate" label="订单金额"><el-input :value="`¥${form.amount || 0}`" disabled /><div class="field-help">金额为下单时的基础服务价格快照，后台不可修改。</div></el-form-item>
        <el-form-item :label="form.order_subtype === 'custom' ? '方案总价' : '合同金额'"><el-input-number v-model="form.contract_amount" :min="0" :precision="2" /></el-form-item>
        <el-form-item :label="form.order_subtype === 'custom' ? '客户应付金额' : '应收团款'"><el-input-number v-model="form.receivable_amount" :min="0" :precision="2" /></el-form-item>
        <el-form-item label="出发地"><el-input v-model="form.departure_place" /></el-form-item>
        <el-form-item label="目的地"><el-input v-model="form.destination" /></el-form-item>
        <el-form-item label="订单分类">
          <el-select v-model="form.order_subtype" :disabled="!!form.source_custom_demand_id" clearable>
            <el-option label="基础服务" value="basic" />
            <el-option label="高端定制" value="custom" />
          </el-select>
        </el-form-item>
        <template v-if="form.order_subtype === 'custom' && !isCreate">
          <el-divider content-position="left">电子方案与报价</el-divider>
          <el-form-item label="方案状态">
            <el-tag :type="form.proposal_status === 'published' ? 'success' : 'warning'">{{ proposalStatusText(form.proposal_status) }}</el-tag>
            <span v-if="form.proposal_published_at" class="field-help inline-help">发布时间：{{ form.proposal_published_at | dateTime }}</span>
          </el-form-item>
          <el-form-item label="方案简介"><el-input v-model="form.proposal_summary" type="textarea" :rows="3" placeholder="概括本次定制路线、节奏与适合人群" /></el-form-item>
          <el-form-item label="路线亮点"><el-input v-model="proposalHighlightsText" type="textarea" :rows="4" placeholder="一行一条，例如：故宫深度讲解" /></el-form-item>
          <el-form-item label="服务包含"><el-input v-model="proposalServicesText" type="textarea" :rows="4" placeholder="一行一项，例如：专属车辆、私人导游、酒店、门票" /></el-form-item>
          <el-form-item label="电子方案文件"><asset-upload v-model="form.proposal_url" type="file" category="proposals" /></el-form-item>
          <el-form-item label="方案文件名称"><el-input v-model="form.proposal_name" placeholder="可选，不填则使用上传文件名" /></el-form-item>
          <el-form-item label="方案上传信息"><el-input :value="fileMeta('proposal')" disabled /></el-form-item>
          <el-alert type="info" :closable="false" title="逐日行程请在下方“逐日行程”中维护；发布前系统会检查方案标题、亮点、服务、每日行程、费用说明、须知和总价。" />
        </template>
        <template v-if="!isCreate">
          <el-divider content-position="left">费用与出行说明</el-divider>
          <el-form-item label="费用包含"><el-input v-model="costIncludesText" :disabled="deliveryDetailsLocked" type="textarea" :rows="4" placeholder="一行一项" /></el-form-item>
          <el-form-item label="费用不含"><el-input v-model="costExcludesText" :disabled="deliveryDetailsLocked" type="textarea" :rows="4" placeholder="一行一项" /></el-form-item>
          <el-form-item label="预订须知"><el-input v-model="form.booking_notice" :disabled="deliveryDetailsLocked" type="textarea" :rows="4" /></el-form-item>
          <el-form-item label="退改规则"><el-input v-model="form.refund_policy" :disabled="deliveryDetailsLocked" type="textarea" :rows="4" /></el-form-item>
          <el-form-item label="出行提醒"><el-input v-model="form.travel_notice" :disabled="deliveryDetailsLocked" type="textarea" :rows="4" /></el-form-item>
          <el-alert
            v-if="form.order_subtype !== 'custom'"
            type="info"
            :closable="false"
            title="基础订单付款后可继续补充费用说明、预订须知、退改规则、出行提醒和逐日行程，并同步展示给客户。"
          />
          <el-alert
            v-else-if="deliveryDetailsLocked"
            type="warning"
            :closable="false"
            title="定制订单付款前已由客户确认费用和须知；付款后不可修改这些内容，但仍可维护行程、服务节点、合同和保险。"
          />
        </template>
        <el-alert v-if="isCreate && form.order_subtype === 'custom'" type="info" :closable="false" title="先创建草稿订单，再进入订单补充电子方案、逐日行程与报价；发布后客户才会看到待支付订单。" />
        <el-form-item label="用户侧状态">
          <el-select v-model="form.user_status" @change="syncOrderStatusFromUserStatus">
            <el-option label="待出行" value="pending_trip" />
            <el-option label="出行中" value="traveling" />
            <el-option label="已完成" value="completed" />
            <el-option label="已退款" value="refunded" />
          </el-select>
        </el-form-item>
        <el-form-item label="出发日期"><el-date-picker v-model="form.travel_date" value-format="yyyy-MM-dd" type="date" /></el-form-item>
        <el-form-item label="返程日期"><el-date-picker v-model="form.end_date" value-format="yyyy-MM-dd" type="date" /></el-form-item>
        <el-form-item label="服务需求"><el-input :value="formatNeeds(form.service_needs_json)" disabled /></el-form-item>
        <el-form-item label="酒店标准"><el-input v-model="form.hotel_level" /></el-form-item>
        <el-form-item label="成人数"><el-input-number v-model="form.adult_count" :min="0" /></el-form-item>
        <el-form-item label="儿童数"><el-input-number v-model="form.child_count" :min="0" /></el-form-item>
        <el-form-item label="老人数"><el-input-number v-model="form.elder_count" :min="0" /></el-form-item>
        <el-form-item label="财务核算"><el-select v-model="form.finance_status"><el-option label="待核算" value="pending"/><el-option label="核算中" value="processing"/><el-option label="已核算" value="completed"/></el-select></el-form-item>
        <el-form-item label="收款状态"><el-input :value="settlementText(form.settlement_status)" disabled /></el-form-item>
        <el-form-item v-if="!isCreate" label="旅客信息">
          <el-table v-loading="travelersLoading" :data="travelers" size="mini" border empty-text="暂无旅客信息">
            <el-table-column prop="name" label="姓名" min-width="90" />
            <el-table-column prop="phone" label="手机号（脱敏）" min-width="130" />
            <el-table-column prop="id_number" label="证件号（脱敏）" min-width="170" />
            <el-table-column v-if="canRevealSensitive" label="敏感操作" width="90">
              <template slot-scope="{ row }"><el-button type="text" @click="revealTraveler(row)">授权查看</el-button></template>
            </el-table-column>
          </el-table>
          <div class="field-help">默认仅显示脱敏信息；授权查看必须填写原因并记录审计日志。</div>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="服务节点">
          <el-button size="mini" type="primary" @click="addStep">新增节点</el-button>
          <el-table :data="steps" size="mini" border empty-text="暂无服务节点">
            <el-table-column prop="title" label="标题" min-width="130" />
            <el-table-column prop="step_status" label="状态" width="130"><template slot-scope="{row}"><el-select :value="row.step_status" size="mini" @change="updateStep(row,{step_status:$event})"><el-option label="待开始" value="pending"/><el-option label="进行中" value="in_progress"/><el-option label="已完成" value="completed"/><el-option label="已取消" value="cancelled"/></el-select></template></el-table-column>
            <el-table-column prop="sort_order" label="排序" width="100"><template slot-scope="{row}"><el-input-number :value="Number(row.sort_order||0)" size="mini" :min="0" controls-position="right" @change="updateStep(row,{sort_order:$event})"/></template></el-table-column>
            <el-table-column label="操作" width="120"><template slot-scope="{row}"><el-button type="text" @click="editStep(row)">编辑</el-button><el-button type="text" class="danger-text" @click="removeStep(row)">删除</el-button></template></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="逐日行程">
          <el-button size="mini" type="primary" @click="openItinerary()">新增行程</el-button>
          <el-table :data="itinerary" size="mini" border empty-text="暂无逐日行程">
            <el-table-column prop="day_no" label="天数" width="70"><template slot-scope="{row}">D{{ row.day_no }}</template></el-table-column>
            <el-table-column prop="itinerary_date" label="日期" width="120"/>
            <el-table-column prop="title" label="标题" min-width="140"/>
            <el-table-column prop="transport" label="交通" min-width="100"/>
            <el-table-column prop="hotel" label="住宿" min-width="120"/>
            <el-table-column label="操作" width="120"><template slot-scope="{row}"><el-button type="text" @click="openItinerary(row)">编辑</el-button><el-button type="text" class="danger-text" @click="removeItinerary(row)">删除</el-button></template></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="门票预约凭证">
          <el-button size="mini" type="primary" @click="openTicketVoucher()">新增景点门票</el-button>
          <el-table :data="ticketVouchers" size="mini" border empty-text="暂无门票预约信息">
            <el-table-column prop="scenic_name" label="景点" min-width="140"/><el-table-column prop="reservation_date" label="预约日期" width="120"/>
            <el-table-column prop="reservation_status" label="状态" width="100"><template slot-scope="{row}">{{ ticketStatusText(row.reservation_status) }}</template></el-table-column>
            <el-table-column prop="voucher_name" label="凭证名称" min-width="150"/><el-table-column label="操作" width="130"><template slot-scope="{row}"><el-button type="text" @click="openTicketVoucher(row)">编辑</el-button><el-button type="text" class="danger-text" @click="removeTicketVoucher(row)">删除</el-button></template></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="经营核算">
          <div class="finance-summary">
            <span>确认收入 <strong>¥{{ money(financeSummary.confirmed_income) }}</strong></span>
            <span>确认成本 <strong>¥{{ money(financeSummary.confirmed_expense) }}</strong></span>
            <span>佣金成本 <strong>¥{{ money(financeSummary.commission_cost) }}</strong></span>
            <span>利润 <strong>¥{{ money(financeSummary.profit) }}</strong></span>
            <span>利润率 <strong>{{ Number(financeSummary.profit_rate || 0).toFixed(2) }}%</strong></span>
          </div>
          <el-button size="mini" type="primary" @click="openFinancial()">新增收支</el-button>
          <el-table :data="financialItems" size="mini" border empty-text="暂无收支记录">
            <el-table-column prop="direction" label="方向" width="80"><template slot-scope="{row}">{{ row.direction==='income'?'收入':'支出' }}</template></el-table-column>
            <el-table-column prop="category" label="分类" width="120"/><el-table-column prop="name" label="名称" min-width="140"/>
            <el-table-column prop="planned_amount" label="计划金额" width="100"/><el-table-column prop="actual_amount" label="实际金额" width="100"/>
            <el-table-column prop="finance_status" label="状态" width="90"><template slot-scope="{row}">{{ financeStatusText(row.finance_status) }}</template></el-table-column>
            <el-table-column prop="supplier_name" label="供应商" min-width="110"/>
            <el-table-column label="操作" width="120"><template slot-scope="{row}"><template v-if="!row.source_type"><el-button type="text" @click="openFinancial(row)">编辑</el-button><el-button type="text" class="danger-text" @click="removeFinancial(row)">删除</el-button></template><span v-else>系统同步</span></template></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="支付记录">
          <el-table :data="payments" size="mini" border empty-text="暂无支付记录">
            <el-table-column prop="payment_no" label="支付单号" min-width="180" />
            <el-table-column prop="amount" label="金额" width="90" />
            <el-table-column prop="payment_status" label="状态" width="100" />
            <el-table-column prop="wechat_transaction_id" label="微信交易号" min-width="180" />
          </el-table>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="增项补款">
          <el-button
            v-if="form.payment_status === 'paid' && !['cancelled', 'completed'].includes(form.status)"
            size="mini"
            type="primary"
            @click="openSupplementCharge"
          >新增补款</el-button>
          <el-table :data="supplementCharges" size="mini" border empty-text="暂无增项补款">
            <el-table-column prop="charge_no" label="补款单号" min-width="190" />
            <el-table-column prop="title" label="增项名称" min-width="140" />
            <el-table-column prop="amount" label="金额" width="100"><template slot-scope="{row}">¥{{ money(row.amount) }}</template></el-table-column>
            <el-table-column prop="charge_status" label="状态" width="100"><template slot-scope="{row}">{{ supplementStatusText(row.charge_status) }}</template></el-table-column>
            <el-table-column prop="paid_at" label="支付时间" width="170"><template slot-scope="{row}">{{ row.paid_at | dateTime }}</template></el-table-column>
            <el-table-column prop="description" label="说明" min-width="160" show-overflow-tooltip />
            <el-table-column label="操作" width="90">
              <template slot-scope="{row}"><el-button v-if="['unpaid','pending'].includes(row.charge_status)" type="text" class="danger-text" @click="cancelSupplementCharge(row)">取消</el-button></template>
            </el-table-column>
          </el-table>
          <div class="field-help">每条增项补款会在原订单下生成独立微信支付单；已支付补款不可修改或取消。</div>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="取消/退款">
          <el-button v-if="!['cancelled','completed'].includes(form.status)" size="mini" type="danger" plain @click="adminRefundOrder">后台发起取消/退款</el-button>
          <el-table :data="refundRequests" size="mini" border empty-text="暂无取消或退款申请">
            <el-table-column prop="request_no" label="申请单号" min-width="190" />
            <el-table-column prop="applicant_type" label="申请方" width="85"><template slot-scope="{row}">{{ row.applicant_type==='user'?'用户':'后台' }}</template></el-table-column>
            <el-table-column prop="reason" label="原因" min-width="150" show-overflow-tooltip />
            <el-table-column prop="requested_amount" label="退款金额" width="100"><template slot-scope="{row}">¥{{ money(row.requested_amount) }}</template></el-table-column>
            <el-table-column prop="request_status" label="状态" width="100"><template slot-scope="{row}">{{ refundStatusText(row.request_status) }}</template></el-table-column>
            <el-table-column label="操作" width="190">
              <template slot-scope="{row}">
                <template v-if="row.request_status==='pending'"><el-button type="text" @click="approveRefund(row)">通过并退款</el-button><el-button type="text" class="danger-text" @click="rejectRefund(row)">拒绝</el-button></template>
                <el-button v-else-if="['processing','partial','failed'].includes(row.request_status)" type="text" @click="reconcileRefund(row)">同步退款</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="field-help">已支付订单审核通过后将逐笔原路退回首款和增项补款；微信受理后需以退款回调或主动同步结果为准。</div>
        </el-form-item>
        <el-form-item v-if="!isCreate" label="推荐佣金">
          <el-table :data="commissions" size="mini" border empty-text="该订单暂无佣金记录">
            <el-table-column prop="recommender_id" label="推荐官ID" width="100" />
            <el-table-column prop="source_type" label="佣金来源" width="100"><template slot-scope="{row}">{{ row.source_type === 'supplement' ? '增项补款' : '原订单' }}</template></el-table-column>
            <el-table-column prop="amount" label="佣金" width="90" />
            <el-table-column label="返佣规则" width="130"><template slot-scope="{row}">{{ commissionRule(row) }}</template></el-table-column>
            <el-table-column prop="status" label="状态" width="100" />
            <el-table-column prop="remark" label="说明" min-width="160" />
          </el-table>
        </el-form-item>
        <template v-if="!isCreate && form.payment_status === 'paid'">
          <el-divider content-position="left">付款后交付文件</el-divider>
          <el-form-item label="电子合同"><asset-upload v-model="form.contract_url" type="file" category="contracts" /></el-form-item>
          <el-form-item label="合同名称"><el-input v-model="form.contract_name" placeholder="不填则按文件名展示" /></el-form-item>
          <el-form-item label="合同上传信息"><el-input :value="fileMeta('contract')" disabled /></el-form-item>
          <el-form-item label="出行险"><asset-upload v-model="form.insurance_url" type="file" category="insurance" /></el-form-item>
          <el-form-item label="保险名称"><el-input v-model="form.insurance_name" placeholder="不填则按文件名展示" /></el-form-item>
          <el-form-item label="保险上传信息"><el-input :value="fileMeta('insurance')" disabled /></el-form-item>
        </template>
        <el-alert v-else-if="!isCreate" type="warning" :closable="false" title="客户支付成功后，基础订单和定制订单均可上传电子合同和旅行意外险。" />
        <el-form-item label="订单状态">
          <el-select v-model="form.status" @change="syncUserStatusFromOrderStatus">
            <el-option label="待处理" value="pending" />
            <el-option label="处理中" value="processing" />
            <el-option label="已完成" value="completed" />
            <el-option label="已取消" value="cancelled" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-input :value="form.payment_status" disabled />
          <div class="field-help">支付状态只能由微信支付回调或“支付记录”页面主动查单更新。</div>
        </el-form-item>
        <el-form-item label="负责员工ID"><el-input-number v-model="form.assigned_admin_id" :min="0" /></el-form-item>
        <el-form-item label="推荐官归因"><el-input :value="form.recommender_code ? `${form.recommender_name || '-'}（${form.recommender_code} / ID ${form.recommender_id || '-'}）` : '无'" disabled /></el-form-item>
        <el-form-item label="员工归因"><el-input :value="form.staff_code ? `${form.staff_name || '-'}（${form.staff_code} / ID ${form.staff_admin_id || '-'}）` : '无'" disabled /></el-form-item>
        <el-form-item label="归因来源"><el-input :value="form.attribution_source || '无'" disabled /><div class="field-help">归因信息为下单时校验后的业务快照，后台不可直接修改。</div></el-form-item>
        <el-form-item label="处理备注"><el-input v-model="form.remark" type="textarea" :rows="5" /></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="closeEditor">关闭</el-button>
        <el-button type="primary" plain :loading="saving" @click="save">{{ isCreate ? '创建方案草稿' : (form.order_subtype === 'custom' && form.proposal_status !== 'published' ? '保存草稿' : '保存订单') }}</el-button>
        <el-button v-if="!isCreate && form.order_subtype === 'custom' && form.payment_status !== 'paid' && form.status !== 'cancelled' && form.payment_status !== 'refunded'" type="success" :loading="saving" @click="publishProposal">保存并发起支付</el-button>
      </div>
    </component>

    <el-dialog title="行程安排" :visible.sync="itineraryVisible" width="560px" append-to-body>
      <el-form :model="itineraryForm" label-width="90px">
        <el-form-item label="第几天"><el-input-number v-model="itineraryForm.day_no" :min="1"/></el-form-item>
        <el-form-item label="日期"><el-date-picker v-model="itineraryForm.itinerary_date" value-format="yyyy-MM-dd" type="date"/></el-form-item>
        <el-form-item label="标题"><el-input v-model="itineraryForm.title"/></el-form-item>
        <el-form-item label="说明"><el-input v-model="itineraryForm.description" type="textarea" :rows="4"/></el-form-item>
        <el-form-item label="交通"><el-input v-model="itineraryForm.transport"/></el-form-item>
        <el-form-item label="用餐"><el-input v-model="itineraryForm.meals"/></el-form-item>
        <el-form-item label="住宿"><el-input v-model="itineraryForm.hotel"/></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="itineraryVisible=false">取消</el-button><el-button type="primary" @click="saveItinerary">保存</el-button></span>
    </el-dialog>

    <el-dialog title="新增增项补款" :visible.sync="supplementVisible" width="520px" append-to-body>
      <el-form :model="supplementForm" label-width="90px">
        <el-form-item label="增项名称"><el-input v-model="supplementForm.title" maxlength="160" placeholder="例如：环球影城门票" /></el-form-item>
        <el-form-item label="补款金额"><el-input-number v-model="supplementForm.amount" :min="0.01" :precision="2" :step="100" /></el-form-item>
        <el-form-item label="项目说明"><el-input v-model="supplementForm.description" type="textarea" :rows="4" maxlength="5000" show-word-limit /></el-form-item>
        <el-form-item label="内部备注"><el-input v-model="supplementForm.remark" type="textarea" :rows="2" maxlength="500" /></el-form-item>
        <el-alert type="info" :closable="false" title="创建后客户将在原订单详情看到该增项，并可直接发起微信补款。" />
      </el-form>
      <span slot="footer"><el-button @click="supplementVisible=false">取消</el-button><el-button type="primary" :loading="savingSupplement" @click="createSupplementCharge">确认创建</el-button></span>
    </el-dialog>
    <el-dialog title="门票预约凭证" :visible.sync="ticketVisible" width="540px" append-to-body>
      <el-form :model="ticketForm" label-width="95px">
        <el-form-item label="景点名称"><el-input v-model="ticketForm.scenic_name" placeholder="例如：故宫博物院"/></el-form-item>
        <el-form-item label="预约日期"><el-date-picker v-model="ticketForm.reservation_date" value-format="yyyy-MM-dd" type="date"/></el-form-item>
        <el-form-item label="预约状态"><el-select v-model="ticketForm.reservation_status"><el-option label="预约中" value="pending"/><el-option label="预约成功" value="reserved"/><el-option label="预约失败" value="failed"/><el-option label="已取消" value="cancelled"/></el-select></el-form-item>
        <el-form-item label="上传凭证"><asset-upload v-model="ticketForm.voucher_url" type="image" category="ticket-vouchers"/></el-form-item>
        <el-form-item label="凭证名称"><el-input v-model="ticketForm.voucher_name" placeholder="例如：故宫门票预约凭证"/></el-form-item>
        <el-form-item label="用户说明"><el-input v-model="ticketForm.remark" type="textarea" :rows="3"/></el-form-item>
      </el-form><span slot="footer"><el-button @click="ticketVisible=false">取消</el-button><el-button type="primary" @click="saveTicketVoucher">保存</el-button></span>
    </el-dialog>

    <el-dialog title="订单收支" :visible.sync="financialVisible" width="600px" append-to-body>
      <el-form :model="financialForm" label-width="100px">
        <el-form-item label="收支方向"><el-radio-group v-model="financialForm.direction"><el-radio label="income">收入</el-radio><el-radio label="expense">支出</el-radio></el-radio-group></el-form-item>
        <el-form-item label="分类"><el-select v-model="financialForm.category" filterable allow-create><el-option v-for="item in financeCategories" :key="item" :label="item" :value="item"/></el-select></el-form-item>
        <el-form-item label="名称"><el-input v-model="financialForm.name"/></el-form-item>
        <el-form-item label="计划金额"><el-input-number v-model="financialForm.planned_amount" :min="0" :precision="2"/></el-form-item>
        <el-form-item label="实际金额"><el-input-number v-model="financialForm.actual_amount" :min="0" :precision="2"/></el-form-item>
        <el-form-item label="确认状态"><el-select v-model="financialForm.finance_status"><el-option label="待确认" value="pending"/><el-option label="已确认" value="confirmed"/><el-option label="已作废" value="voided"/></el-select></el-form-item>
        <el-form-item label="发生日期"><el-date-picker v-model="financialForm.occurred_at" value-format="yyyy-MM-dd" type="date"/></el-form-item>
        <el-form-item label="供应商"><el-input v-model="financialForm.supplier_name"/></el-form-item>
        <el-form-item label="方式"><el-input v-model="financialForm.payment_method"/></el-form-item>
        <el-form-item label="备注"><el-input v-model="financialForm.remark" type="textarea"/></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="financialVisible=false">取消</el-button><el-button type="primary" @click="saveFinancial">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import AssetUpload from "../components/AssetUpload.vue";
import PagedTable from "../components/PagedTable.vue";
import StatusTag from "../components/StatusTag.vue";
import { listResource, updateResource } from "../api/resources";
import { getCurrentUser } from "../api/auth";
import http from "../api/http";

export default {
  name: "ServiceOrdersManage",
  components: { AssetUpload, PagedTable, StatusTag },
  props: { embedded: Boolean, beforeSave: Function },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      isCreate: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "", finance_status: "", settlement_status: "" },
      form: {},
      travelers: [],
      travelersLoading: false,
      currentAdmin: null,
      steps: [],
      payments: [],
      supplementCharges: [],
      refundRequests: [],
      ticketVouchers: [],
      commissions: [],
      itinerary: [],
      financialItems: [],
      financeSummary: {},
      proposalHighlightsText: "",
      proposalServicesText: "",
      costIncludesText: "",
      costExcludesText: "",
      itineraryVisible: false,
      itineraryForm: {},
      financialVisible: false,
      financialForm: {},
      supplementVisible: false,
      savingSupplement: false,
      supplementForm: { title: "", amount: 0.01, description: "", remark: "" },
      ticketVisible: false,
      ticketForm: {},
      financeCategories: ["团款", "退款", "酒店", "车辆", "门票", "导游", "餐饮", "保险", "佣金", "其他"]
    };
  },
  mounted() {
    if (!this.embedded) this.fetchList();
    this.fetchCurrentAdmin();
    if (!this.embedded && this.$route.query && this.$route.query.user_id) this.openCreate(this.$route.query);
  },
  computed: {
    deliveryDetailsLocked() {
      return !this.isCreate && this.form.order_subtype === "custom" && this.form.payment_status === "paid";
    },
    canRevealSensitive() {
      const admin = this.currentAdmin || {};
      return admin.role_code === "super_admin" || (admin.permissions || []).includes("sensitive-data:reveal");
    }
  },
  methods: {
    async fetchCurrentAdmin() {
      try {
        const res = await getCurrentUser();
        this.currentAdmin = res.data && res.data.user ? res.data.user : null;
      } catch (error) {
        this.currentAdmin = null;
      }
    },
    closeEditor() {
      this.drawerVisible = false;
      this.$emit("close");
    },
    async fetchList() {
      if (this.embedded) return;
      this.loading = true;
      try {
        const res = await listResource("service-orders", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "", finance_status: "", settlement_status: "" };
      this.page = 1;
      this.fetchList();
    },
    orderTypeText(value) {
      const map = {
        consult: "咨询订单",
        service: "服务订单",
        custom: "定制订单",
        route: "线路订单"
      };
      return map[value] || value || "-";
    },
    orderSubtypeText(value) {
      const map = {
        basic: "基础服务",
        custom: "高端定制",
        route: "线路定制"
      };
      return map[value] || value || "-";
    },
    money(value) { return Number(value || 0).toFixed(2); },
    commissionRule(row) {
      let snapshot = row && row.rule_snapshot_json;
      if (typeof snapshot === "string") { try { snapshot = JSON.parse(snapshot); } catch (error) { snapshot = {}; } }
      if (snapshot && snapshot.commission_mode === "fixed") return `固定 ¥${this.money(snapshot.commission_fixed_amount)}`;
      return row && row.commission_rate !== null ? `比例 ${Number(row.commission_rate || 0) * 100}%` : "-";
    },
    settlementText(value) { return ({unsettled:"未收款",partial:"部分收款",settled:"已结清",refunded:"已退款"})[value] || "未收款"; },
    financeStatusText(value) { return ({pending:"待确认",confirmed:"已确认",voided:"已作废"})[value] || value || "-"; },
    supplementStatusText(value) { return ({unpaid:"待支付",pending:"支付中",paid:"已支付",cancelled:"已取消",refunded:"已退款"})[value] || value || "-"; },
    refundStatusText(value) { return ({pending:"待审核",approved:"已通过",processing:"退款中",partial:"部分退款",success:"已退款",failed:"退款失败",rejected:"已拒绝"})[value] || value || "-"; },
    ticketStatusText(value) { return ({pending:"预约中",reserved:"预约成功",failed:"预约失败",cancelled:"已取消"})[value] || value || "-"; },
    proposalStatusText(value) { return value === "published" ? "已发布" : "草稿"; },
    arrayValue(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];
      try { const parsed = JSON.parse(value); return Array.isArray(parsed) ? parsed : []; } catch (error) { return []; }
    },
    lines(value) { return String(value || "").split("\n").map((item) => item.trim()).filter(Boolean); },
    syncProposalEditors(order = {}) {
      this.proposalHighlightsText = this.arrayValue(order.proposal_highlights_json || order.proposal_highlights).join("\n");
      this.proposalServicesText = this.arrayValue(order.proposal_services_json || order.proposal_services).join("\n");
      this.costIncludesText = this.arrayValue(order.cost_includes_json || order.cost_includes).join("\n");
      this.costExcludesText = this.arrayValue(order.cost_excludes_json || order.cost_excludes).join("\n");
    },
    orderPayload() {
      return {
        ...this.form,
        travel_date: this.$formatDate(this.form.travel_date, ""),
        end_date: this.$formatDate(this.form.end_date, ""),
        proposal_highlights_json: this.lines(this.proposalHighlightsText),
        proposal_services_json: this.lines(this.proposalServicesText),
        cost_includes_json: this.lines(this.costIncludesText),
        cost_excludes_json: this.lines(this.costExcludesText)
      };
    },
    openCreate(seed = {}) {
      const initial = seed && seed.user_id ? seed : {};
      this.isCreate = true;
      this.form = {
        user_id: initial.user_id ? Number(initial.user_id) : null,
        name: initial.name || "旅游服务订单",
        amount: 0,
        contract_amount: 0,
        receivable_amount: 0,
        currency: "CNY",
        finance_status: "pending",
        settlement_status: "unsettled",
        order_subtype: "custom",
        user_status: "pending_trip",
        status: "pending",
        travel_date: this.$formatDate(initial.travel_date, ""),
        adult_count: initial.adult_count !== undefined ? Number(initial.adult_count) : 1,
        child_count: Number(initial.child_count || 0),
        elder_count: Number(initial.elder_count || 0),
        hotel_level: initial.hotel_level || "",
        service_needs_json: this.arrayValue(initial.service_needs_json),
        remark: initial.demand_id ? `来源定制需求 ID：${initial.demand_id}` : ""
      };
      this.travelers=[];this.steps=[];this.payments=[];this.supplementCharges=[];this.refundRequests=[];this.ticketVouchers=[];this.commissions=[];this.itinerary=[];this.financialItems=[];this.financeSummary={};
      this.syncProposalEditors();
      this.drawerVisible = true;
    },
    async openEdit(row) {
      this.isCreate = false;
      this.form = {
        ...row,
        assigned_admin_id: Number(row.assigned_admin_id || 0),
        amount: Number(row.amount || 0),
        travel_date: this.$formatDate(row.travel_date, ""),
        end_date: this.$formatDate(row.end_date, ""),
        adult_count: Number(row.adult_count || 0),
        child_count: Number(row.child_count || 0),
        elder_count: Number(row.elder_count || 0),
        user_status: row.user_status || "pending_trip",
        order_subtype: row.order_subtype || "basic"
      };
      this.drawerVisible = true;
      this.travelers = [];
      this.travelersLoading = true;
      try {
        const res = await http.get(`/service-orders/${row.id}/detail`);
        const detail = res.data || {};
        this.form = {
          ...this.form,
          ...detail,
          travel_date: this.$formatDate(detail.travel_date || this.form.travel_date, ""),
          end_date: this.$formatDate(detail.end_date || this.form.end_date, ""),
          adult_count: Number(detail.adult_count || 0),
          child_count: Number(detail.child_count || 0),
          elder_count: Number(detail.elder_count || 0)
        };
        this.syncProposalEditors(detail);
        this.travelers = detail.travelers || [];
        this.steps = detail.steps || [];
        this.payments = detail.payments || [];
        this.supplementCharges = detail.supplement_charges || [];
        this.refundRequests = detail.refund_requests || [];
        this.ticketVouchers = detail.ticket_vouchers || [];
        this.commissions = detail.commissions || [];
        this.itinerary = detail.itinerary || [];
        this.financialItems = detail.financial_items || [];
        this.financeSummary = detail.finance_summary || {};
      } finally {
        this.travelersLoading = false;
      }
    },
    fileMeta(type) {
      const by = this.form[`${type}_uploaded_by`];
      const at = this.form[`${type}_uploaded_at`];
      return by || at ? `上传人ID：${by || '-'}；上传时间：${this.$formatDateTime(at)}` : "尚未记录上传元数据";
    },
    async reloadDetail() {
      const res = await http.get(`/service-orders/${this.form.id}/detail`);
      const detail=res.data||{}; this.$set(this.form,"receivable_amount",Number(detail.receivable_amount||0));this.$set(this.form,"settlement_status",detail.settlement_status||"unsettled");this.$set(this.form,"payment_status",detail.payment_status||this.form.payment_status);this.$set(this.form,"status",detail.status||this.form.status);this.steps=detail.steps||[]; this.payments=detail.payments||[]; this.supplementCharges=detail.supplement_charges||[];this.refundRequests=detail.refund_requests||[];this.ticketVouchers=detail.ticket_vouchers||[]; this.commissions=detail.commissions||[]; this.travelers=detail.travelers||[];this.itinerary=detail.itinerary||[];this.financialItems=detail.financial_items||[];this.financeSummary=detail.finance_summary||{};
    },
    async addStep() {
      try { const p=await this.$prompt("请输入服务节点标题","新增服务节点",{inputValidator:v=>String(v||"").trim()?true:"标题不能为空"}); await http.post(`/service-orders/${this.form.id}/steps`,{title:p.value,step_status:"pending",sort_order:this.steps.length}); await this.reloadDetail(); } catch(error){ if(error!=="cancel"&&error!=="close"&&error.message)this.$message.error(error.message); }
    },
    async editStep(row) {
      try { const p=await this.$prompt("修改节点标题","编辑服务节点",{inputValue:row.title}); await http.put(`/service-orders/${this.form.id}/steps/${row.id}`,{...row,title:p.value}); await this.reloadDetail(); } catch(error){ if(error!=="cancel"&&error!=="close"&&error.message)this.$message.error(error.message); }
    },
    async updateStep(row, patch) { await http.put(`/service-orders/${this.form.id}/steps/${row.id}`,{...row,...patch}); await this.reloadDetail(); },
    async removeStep(row) { await this.$confirm("确认删除该服务节点？","提示",{type:"warning"}); await http.delete(`/service-orders/${this.form.id}/steps/${row.id}`); await this.reloadDetail(); },
    openItinerary(row = null) { this.itineraryForm=row?{...row}:{day_no:this.itinerary.length+1,itinerary_date:"",title:"",description:"",transport:"",meals:"",hotel:"",sort_order:this.itinerary.length};this.itineraryVisible=true; },
    async saveItinerary() { const data={...this.itineraryForm};if(data.id)await http.put(`/service-orders/${this.form.id}/itinerary/${data.id}`,data);else await http.post(`/service-orders/${this.form.id}/itinerary`,data);this.itineraryVisible=false;await this.reloadDetail(); },
    async removeItinerary(row) { await this.$confirm("确认删除该日行程？","提示",{type:"warning"});await http.delete(`/service-orders/${this.form.id}/itinerary/${row.id}`);await this.reloadDetail(); },
    openTicketVoucher(row=null){this.ticketForm=row?{...row}:{scenic_name:"",reservation_date:"",reservation_status:"pending",voucher_url:"",voucher_name:"",remark:"",sort_order:this.ticketVouchers.length};this.ticketVisible=true;},
    async saveTicketVoucher(){if(!String(this.ticketForm.scenic_name||"").trim()){this.$message.warning("请填写景点名称");return;}const data={...this.ticketForm};if(data.id)await http.put(`/service-orders/${this.form.id}/ticket-vouchers/${data.id}`,data);else await http.post(`/service-orders/${this.form.id}/ticket-vouchers`,data);this.ticketVisible=false;await this.reloadDetail();this.$message.success("门票预约信息已保存");},
    async removeTicketVoucher(row){await this.$confirm(`确认删除“${row.scenic_name}”门票信息？`,"提示",{type:"warning"});await http.delete(`/service-orders/${this.form.id}/ticket-vouchers/${row.id}`);await this.reloadDetail();},
    openSupplementCharge() {
      this.supplementForm = { title: "", amount: 0.01, description: "", remark: "" };
      this.supplementVisible = true;
    },
    async createSupplementCharge() {
      if (!String(this.supplementForm.title || "").trim()) { this.$message.warning("请填写增项名称"); return; }
      if (!(Number(this.supplementForm.amount) > 0)) { this.$message.warning("补款金额必须大于0"); return; }
      this.savingSupplement = true;
      try {
        await http.post(`/service-orders/${this.form.id}/supplement-charges`, this.supplementForm);
        this.supplementVisible = false;
        await this.reloadDetail();
        await this.fetchList();
        this.$message.success("增项补款已创建，客户可在原订单中支付");
      } finally {
        this.savingSupplement = false;
      }
    },
    async cancelSupplementCharge(row) {
      await this.$confirm(`确认取消增项补款“${row.title}”？取消后订单应收金额会相应减少。`, "取消补款", { type: "warning" });
      await http.post(`/service-orders/${this.form.id}/supplement-charges/${row.id}/cancel`);
      await this.reloadDetail();
      await this.fetchList();
      this.$message.success("增项补款已取消");
    },
    async adminRefundOrder() {
      const prompt = await this.$prompt("请输入取消/退款原因。已支付订单将逐笔原路退回全部微信支付款项。", "后台发起取消/退款", { inputType:"textarea", inputValidator:v=>String(v||"").trim().length>=2||"原因不少于2个字", type:"warning" });
      await http.post(`/service-orders/${this.form.id}/refund-requests`, { reason: prompt.value });
      await this.reloadDetail();await this.fetchList();this.$message.success(this.form.payment_status==='refunded'?"退款已完成":"取消/退款已提交微信处理");
    },
    async approveRefund(row) {
      await this.$confirm("审核通过后将立即向微信发起退款，是否继续？","审核退款",{type:"warning"});
      await http.post(`/service-orders/${this.form.id}/refund-requests/${row.id}/approve`,{});
      await this.reloadDetail();await this.fetchList();this.$message.success("退款已提交微信处理");
    },
    async rejectRefund(row) {
      const prompt=await this.$prompt("请填写拒绝原因","拒绝退款",{inputType:"textarea",inputValidator:v=>String(v||"").trim().length>=2||"拒绝原因不少于2个字"});
      await http.post(`/service-orders/${this.form.id}/refund-requests/${row.id}/reject`,{remark:prompt.value});await this.reloadDetail();
    },
    async reconcileRefund(row) {
      await http.post(`/service-orders/${this.form.id}/refund-requests/${row.id}/reconcile`,{});await this.reloadDetail();await this.fetchList();this.$message.success("退款状态已同步");
    },
    openFinancial(row = null) { this.financialForm=row?{...row}:{direction:"expense",category:"酒店",name:"",planned_amount:0,actual_amount:0,finance_status:"pending",occurred_at:"",supplier_name:"",payment_method:"",remark:""};this.financialVisible=true; },
    async saveFinancial() { const data={...this.financialForm};if(data.id)await http.put(`/service-orders/${this.form.id}/financial-items/${data.id}`,data);else await http.post(`/service-orders/${this.form.id}/financial-items`,data);this.financialVisible=false;await this.reloadDetail();await this.fetchList(); },
    async removeFinancial(row) { await this.$confirm("确认删除该收支记录？","提示",{type:"warning"});await http.delete(`/service-orders/${this.form.id}/financial-items/${row.id}`);await this.reloadDetail();await this.fetchList(); },
    async revealTraveler(row) {
      try {
        const prompt = await this.$prompt("请填写本次查看完整证件号/手机号的业务原因", "敏感信息授权查看", {
          confirmButtonText: "确认查看",
          cancelButtonText: "取消",
          inputType: "textarea",
          inputValidator: (value) => String(value || "").trim().length >= 4 || "查看原因不少于4个字"
        });
        const res = await http.post(`/sensitive-data/order-travelers/${row.id}/reveal`, { reason: prompt.value });
        const item = res.data || {};
        await this.$alert(`姓名：${item.name || "-"}\n手机号：${item.phone || "-"}\n证件号：${item.id_number || "-"}`, "已授权的旅客信息", {
          confirmButtonText: "关闭"
        });
      } catch (error) {
        if (error !== "cancel" && error !== "close" && error.message) this.$message.error(error.message);
      }
    },
    formatNeeds(value) {
      if (!value) return "-";
      if (Array.isArray(value)) return value.length ? value.join("、") : "-";
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) && parsed.length ? parsed.join("、") : "-";
      } catch (error) {
        return String(value);
      }
    },
    syncOrderStatusFromUserStatus(status) {
      if (status === "completed") this.$set(this.form, "status", "completed");
    },
    syncUserStatusFromOrderStatus(status) {
      if (status === "completed") this.$set(this.form, "user_status", "completed");
    },
    async save() {
      if (this.saving) return;
      this.saving = true;
      try {
        if (this.beforeSave) await this.beforeSave();
        const res = this.isCreate
          ? await http.post("/service-orders/manual", this.orderPayload())
          : await updateResource("service-orders", this.form.id, this.orderPayload());
        this.form = { ...this.form, ...(res.data || {}) };
        await this.fetchList();
        this.$emit("saved", this.form);
        this.$message.success(this.isCreate ? "草稿已创建，请继续完善方案" : "订单已保存");
        if (this.isCreate) await this.openEdit(this.form);
        else if (!this.embedded) this.drawerVisible = false;
      } finally {
        this.saving = false;
      }
    },
    proposalMissingFields() {
      const missing = [];
      for (const [field, label] of [["name", "方案标题"], ["proposal_summary", "方案简介"], ["booking_notice", "预订须知"], ["refund_policy", "退改规则"], ["travel_notice", "出行提醒"]]) {
        if (!String(this.form[field] || "").trim()) missing.push(label);
      }
      for (const [text, label] of [[this.proposalHighlightsText, "路线亮点"], [this.proposalServicesText, "服务包含"], [this.costIncludesText, "费用包含"], [this.costExcludesText, "费用不含"]]) {
        if (!this.lines(text).length) missing.push(label);
      }
      if (!this.itinerary.length) missing.push("逐日行程");
      if (!(Number(this.form.receivable_amount || this.form.contract_amount) > 0)) missing.push("方案总价");
      return missing;
    },
    async publishProposal() {
      if (this.saving) return;
      const missing = this.proposalMissingFields();
      if (missing.length) {
        this.$alert(`请先完善：${missing.join("、")}`, "暂时无法发起支付", { type: "warning" });
        return;
      }
      this.saving = true;
      try {
        if (this.beforeSave) await this.beforeSave();
        await updateResource("service-orders", this.form.id, this.orderPayload());
        const res = await http.post(`/service-orders/${this.form.id}/proposal/publish`);
        this.form = { ...this.form, ...(res.data || {}) };
        await this.fetchList();
        this.$emit("saved", this.form);
        this.$message.success("电子方案已发布，客户可在小程序确认并支付");
        if (!this.embedded) this.drawerVisible = false;
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.field-help {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
.finance-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  margin-bottom: 10px;
  padding: 10px 14px;
  background: #f7f8fa;
  border-radius: 6px;
}
.finance-summary strong { margin-left: 6px; color: #303133; }
.danger-text { color: #f56c6c; }
</style>
